import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { createFileRoute } from "@tanstack/react-router";
import { Package, ShoppingBag, ShoppingBasket } from "lucide-react";
import { SupportLinkRow } from "~/components/SupportLinkRow";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";

export const Route = createFileRoute("/support/how-to-use/")({
	beforeLoad: () => {
		document.title = "bacehub | Chat & Support";
	},
	component: RouteComponent,
});

export default function RouteComponent() {
	const i18n = useI18nContext().LL["new-ui"];
	const guideItems = [
		{
			icon: ShoppingBasket,
			title: i18n.INSTANT_BUY_SUPPORT_TITLE(),
			to: "/support/how-to-use/instant-buy",
		},
		{
			icon: ShoppingBag,
			title: i18n.SHOP_N_COLLECT_TITLE(),
			to: "/support/how-to-use/shop-and-collect",
		},
		{
			icon: Package,
			title: i18n.CLICK_AND_COLLECT_TITLE(),
			to: "/support/how-to-use/click-and-collect",
		},
	];

	return (
		<PageContainer>
			<AppHeader service="ALL" />
			<h1 className="px-6 py-2 text-2xl font-breit">
				<T>{i18n.HOW_TO_USE()}</T>
			</h1>
			<div className="mx-6">
				{guideItems.map((item) => (
					<SupportLinkRow key={item.title} {...item} />
				))}
			</div>
		</PageContainer>
	);
}
